import { getDocs, collection } from "@firebase/firestore";
import { hideLoading, setItemsList, showLoading } from "./items-list-slice";

export const getItemsService = async (dispatch, db, coll) => {
    dispatch(showLoading());
    try {
        await getDocs(collection(db, coll))
        .then((querySnapshot) => {
            const data = querySnapshot.docs
                .map((doc) => ({...doc.data(), id:doc.id}));
            dispatch(setItemsList(data));
        });
    } catch(e) {
        console.error("ItemsList getItemsService error: ", e);
    }
    finally {
        // This block will always execute, even if there's an exception
        dispatch(hideLoading()); // Make sure this is here
    }
};